import { render } from "./PromptType.vue?vue&type=template&id=50b03b40&scoped=true"
import script from "./PromptType.vue?vue&type=script&lang=js"
export * from "./PromptType.vue?vue&type=script&lang=js"

import "./PromptType.vue?vue&type=style&index=0&id=50b03b40&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b03b40"]])

export default __exports__